var TableView = require('billy-webapp/ui/list/table/table-view')

module.exports = TableView.extend()
